/**
 * Утилита копирования произвольного текста (email, телефон, токен и т.д.)
 * со всеми фолбэками для несекьюрных контекстов и старых браузеров.
 * Возвращает Promise<boolean> — true, если действительно скопировано.
 */
export async function copyToClipboard(text) {
    if (text == null) return false;
    const value = String(text);
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(value);
            return true;
        }
    } catch (e) {
        // продолжаем к фолбэку
    }

    try {
        const ta = document.createElement('textarea');
        ta.value = value;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '0';
        ta.style.left = '0';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand && document.execCommand('copy');
        document.body.removeChild(ta);
        return !!ok;
    } catch (e) {
        return false;
    }
}

/**
 * Vue-mixin-метод: копировать email и показать стандартное уведомление.
 * Использование: `@click.prevent="copyEmail('info@example.com')"`.
 * Требует подключённый ui-модуль Vuex (см. store/ui.js).
 */
export async function copyEmailWithToast($store, email) {
    const ok = await copyToClipboard(email);
    if (ok) {
        $store.dispatch('ui/showSuccess', 'Адрес электронной почты скопирован!');
    } else {
        $store.dispatch('ui/showError', 'Не удалось скопировать. Скопируйте вручную: ' + email);
    }
    return ok;
}
